<template>
  <div v-if="!over" class="big-countdown d-flex align-center text-center">
    <p>
      <span class="number">
        <transition @enter="enter" @leave="leave">
          <span :key="numberOf.days" class="d-flex justify-center p-relative">
            <span v-if="numberOf.days < 10">0</span>
            <span>{{ numberOf.days }}</span>
          </span>
        </transition>
      </span>
      <span class="d-block text-small text-md-base">{{
        $tc('countdown.days', numberOf.days)
      }}</span>
    </p>
    <p class="interval">
      <span>:</span>
    </p>
    <p>
      <span class="number">
        <transition @enter="enter" @leave="leave">
          <span :key="numberOf.hours" class="d-flex justify-center p-relative">
            <span v-if="numberOf.hours < 10">0</span>
            <span>{{ numberOf.hours }}</span>
          </span>
        </transition>
      </span>
      <span class="d-block text-small text-md-base">{{
        $tc('countdown.hours', numberOf.hours)
      }}</span>
    </p>
    <p class="interval">
      <span>:</span>
    </p>
    <p>
      <span class="number">
        <transition @enter="enter" @leave="leave">
          <span
            :key="numberOf.minutes"
            class="d-flex justify-center p-relative"
          >
            <span v-if="numberOf.minutes < 10">0</span>
            <span>{{ numberOf.minutes }}</span>
          </span>
        </transition>
      </span>
      <span class="d-block text-small text-md-base">{{
        $tc('countdown.minutes', numberOf.minutes)
      }}</span>
    </p>
    <p class="interval">
      <span>:</span>
    </p>
    <p>
      <span class="number">
        <transition @enter="enter" @leave="leave">
          <span
            :key="numberOf.seconds"
            class="d-flex justify-center p-relative"
          >
            <span v-if="numberOf.seconds < 10">0</span>
            <span>{{ numberOf.seconds }}</span>
          </span>
        </transition>
      </span>
      <span class="d-block text-small text-md-base">{{
        $tc('countdown.seconds', numberOf.seconds)
      }}</span>
    </p>
  </div>
</template>

<script>
const one = {
  day: 1000 * 60 * 60 * 24,
  hour: 1000 * 60 * 60,
  minute: 1000 * 60,
  second: 1000,
}

export default {
  name: 'BigCountDown',
  props: {
    date: {
      type: Date,
      required: true,
    },
    home: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    numberOf: {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    },
    over: false,
    interval: null,
  }),
  mounted() {
    if (!this.date) {
      this.over = true
      return
    }

    this.countdown()

    this.interval = setInterval(() => {
      this.countdown()
    }, 1000)
  },
  methods: {
    countdown() {
      const now = new Date()

      const endTime = this.date.getTime()
      const nowTime = now.getTime()

      if (endTime > nowTime) {
        const timeDuration = endTime - nowTime

        this.numberOf = {
          days: Math.floor(timeDuration / one.day),
          hours: Math.floor((timeDuration % one.day) / one.hour),
          minutes: Math.floor((timeDuration % one.hour) / one.minute),
          seconds: Math.floor((timeDuration % one.minute) / one.second),
        }

        return
      }

      this.over = true
      clearInterval(this.interval)
    },

    async enter(el, done) {
      const { gsap } = await import('gsap' /* webpackChunkName: 'gsap' */)

      gsap.from(el, {
        bottom: '30px',
        scale: 0.8,
        width: el.offsetWidth,
        letterSpacing: '0.2em',
        opacity: 0,
        duration: 0.5,
        onComplete: done,
      })
    },

    async leave(el, done) {
      const { gsap } = await import('gsap' /* webpackChunkName: 'gsap' */)
      gsap.to(el, {
        bottom: '-30px',
        letterSpacing: '-0.2em',
        width: el.offsetWidth,
        scale: 0.6,
        opacity: 0,
        duration: 0.5,
        onComplete: done,
      })
    },
  },
}
</script>

<style lang="scss">
.big-countdown {
  .number,
  .interval {
    margin-bottom: 0;
    position: relative;
    color: var(--tertiary-color);
    font-family: var(--secondary-font-family);
  }

  p {
    margin-bottom: 0;
  }

  .number {
    display: block;
    font-size: var(--h2-font-size);
    min-width: rem(50px);
    line-height: 1;

    @include mq($from: tablet) {
      font-size: var(--countdown-font-size);
    }
  }

  .interval {
    display: flex;
    align-items: flex-start;
    font-size: rem(32px);
    line-height: 1.1;
    margin: 0 calc(var(--spacing) * 0.2);
    height: rem(62px);
  }

  .v-leave-active {
    position: absolute;
    width: 100%;
  }
}
</style>
